import { createFileRoute } from "@tanstack/react-router";
import BlogMeerSpelers from "@/pages/BlogMeerSpelers";

export const Route = createFileRoute("/blog/meer-spelers-naar-husselavond")({
  head: () => ({
    meta: [
      { title: "5 manieren om meer spelers naar je husselavond te trekken | De Hussel App" },
      { name: "description", content: "Te weinig opkomst op je husselavond? Deze 5 praktijkbewezen tactieken helpen tennisverenigingen om wekelijks meer leden op de baan te krijgen." },
      { property: "og:title", content: "5 manieren om meer spelers naar je husselavond te trekken | De Hussel App" },
      { property: "og:description", content: "Te weinig opkomst op je husselavond? Deze 5 praktijkbewezen tactieken helpen tennisverenigingen om wekelijks meer leden op de baan te krijgen." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/blog/meer-spelers-naar-husselavond" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/blog/meer-spelers-naar-husselavond" }],
  }),
  component: BlogMeerSpelers,
});
